<template>
    <div ref="title" class="function-title-container">
        <div
            v-if="functionTitle.colorTitle"
            class="function-colortitle"
            :class="`color-${props.colorIndex}`"
            v-html="$t(functionTitle.colorTitle)"
        />
        <div class="function-title" :class="`title-${props.colorIndex}`" v-html="$t(functionTitle.title)" />
        <!-- ""就不显示 -->
        <div v-if="functionTitle.subTitle" class="function-subtitle">
            {{ $t(functionTitle.subTitle) }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    gsap.registerPlugin(ScrollTrigger);

    const props = defineProps<{
        functionTitle: FunctionTitle;
        colorIndex: number;
    }>();

    const title = ref(null);
    onMounted(() => {
        // console.log(title);

        // addSlideInUp(title.value)
        addSlideInUp('.function-title-container ');

        // 文字出现
        // const t1 = gsap.timeline({
        //     scrollTrigger: {
        //         markers: { startColor: 'green', endColor: 'red', fontSize: '12px' },
        //         trigger: '.function-title-container ',
        //         scrub: 1.2,// 延迟几秒滚动
        //         // start: "top 90%",
        //         start: 'top bottom',
        //         end: 'center center',
        //     },
        // });
        // t1.fromTo(['.function-colortitle', '.function-title'], {
        //     opacity: 0,
        //     yPercent: 50,

        // },{
        //     yPercent: 0,
        //     // rotation: 5,
        //     opacity: 1,
        //     stagger: 0.1, // 动画间隔
        // });
        // 图片
        // gsap.fromTo(
        //     '.products-ending-img',
        //     {
        //         opacity: 0,
        //         yPercent: 20,
        //     },
        //     {
        //         yPercent: 0,
        //         opacity: 1,
        //         stagger: 0.1, // 动画间隔
        //         delay: 0.3,
        //         scrollTrigger: {
        //             trigger: '.products-ending-img',
        //             start: 'top 100%',
        //         },
        //     },
        // );

        // 文字移动
        // const t2 = gsap.timeline({
        //     scrollTrigger: {
        //         // markers: { startColor: "green", endColor: "red", fontSize: "12px" },
        //         trigger: '.products-ending-title',
        //         scrub: 1.2, // 延迟几秒滚动
        //         start: 'center 80%',
        //     },
        // });
        // t2.to('.svg-left', {
        //     xPercent: 15,
        // });
        // t2.to(
        //     '.text-right',
        //     {
        //         xPercent: -15,
        //     },
        //     '<',
        // );
    });
    // console.log(props.functionTitle.subTitle)
</script>

<style lang="less" scoped>
    .function-title-container {
        // font-family: Montserrat, 'HarmonyOS Sans SC';
        font-family: 'HarmonyOS Sans SC', Montserrat;

        .color {
            &-0 {
                color: #0075ff;
            }

            &-1 {
                color: #ffff00;
            }

            &-2 {
                color: #37e6fe;
            }
            // atelier 页面
            &-4 {
                color: #ff00ff;
            }
            &-5 {
                color: #00ff00;
            }
            &-6 {
                color: #2651ff;
            }
            &-7 {
                color: #00c8be;
            }
        }
        .title {
            &-4 {
                :deep(.gradientText) {
                    background: linear-gradient(90deg, #a017ff 0%, #f0f 48.65%, #ff932f 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            &-5 {
                :deep(.gradientText) {
                    background: linear-gradient(90deg, #0f0 0%, #33fdff 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                :deep(.gradientText2) {
                    background: linear-gradient(90deg, #37e8ff 0%, #4a74ff 100%);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
        }
        .function {
            &-colortitle {
                font-size: .convert(@font-size-xl) [ @vw]; //24px
                font-weight: 500;
                text-transform: capitalize;
                line-height: normal;
                font-family: Montserrat;
                // margin-bottom: .convert(@margin-sm)[@vw];
            }

            &-title {
                font-size: .convert(@font-size-title) [ @vw]; //48px
                color: #fff;
                line-height: normal;
                padding-top: .convert(@padding-sm) [ @vw];
            }

            &-subtitle {
                font-family: 'HarmonyOS Sans SC';
                padding-top: .convert(@padding-sm) [ @vw]; //12px
                color: var(--gray-8, #bfbfbf);
                font-size: .convert(@font-size-xl) [ @vw]; //24px
                line-height: normal;
            }
        }

        @media (max-width: @screen-mobile-width) {
            .function {
                &-colortitle {
                    font-size: .convert(@font-size-xm) [ @vw-mobile]; //12px
                    margin-bottom: .convert(5px) [ @vw-mobile];
                }

                &-title {
                    font-size: .convert(20px) [ @vw-mobile]; //20px
                    // padding-top: .convert(5px) [ @vw-mobile];
                }

                &-subtitle {
                    font-size: .convert(@font-size-md) [ @vw-mobile]; //14px
                    // padding-top: .convert(@padding-xxs) [ @vw-mobile];//4px
                }
            }
        }
    }
</style>
